import { Directive, ElementRef, Input, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { KeyboardShortcutsService, ShortcutCommand } from '../service/keyboard-shortcuts.service';

@Directive({
  selector: '[appKeyboardShortcut]'
})
export class KeyboardShortcutDirective implements OnInit, OnDestroy {
  @Input() shortcutKeys: string[] = [];
  @Input() shortcutDescription = '';
  @Input() shortcutAction: () => void = () => {
    console.log()
  };
  @Input() showHint = true;

  private command: ShortcutCommand | null = null;
  private tooltipElement: HTMLElement | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private keyboardService: KeyboardShortcutsService
  ) {}

  ngOnInit(): void {
    if (this.shortcutKeys.length && this.shortcutAction) {
      // Register the shortcut
      this.command = {
        keys: this.shortcutKeys,
        description: this.shortcutDescription,
        action: this.shortcutAction
      };
      this.keyboardService.register(this.command);

      // Add tooltip if showHint is true
      if (this.showHint) {
        this.createTooltip();

        // Add mouseover/mouseout events
        this.renderer.listen(this.el.nativeElement, 'mouseenter', () => {
          this.showTooltip();
        });

        this.renderer.listen(this.el.nativeElement, 'mouseleave', () => {
          this.hideTooltip();
        });
      }

      // Add the shortcut info as data attributes
      this.renderer.setAttribute(
        this.el.nativeElement,
        'data-shortcut',
        this.keyboardService.formatShortcut(this.shortcutKeys)
      );
    }
  }

  ngOnDestroy(): void {
    if (this.command) {
      this.keyboardService.unregister(this.shortcutKeys);
    }
    if (this.tooltipElement) {
      this.renderer.removeChild(document.body, this.tooltipElement);
    }
  }

  private createTooltip(): void {
    this.tooltipElement = this.renderer.createElement('div');
    this.renderer.addClass(this.tooltipElement, 'keyboard-shortcut-tooltip');
    this.renderer.setStyle(this.tooltipElement, 'position', 'absolute');
    this.renderer.setStyle(this.tooltipElement, 'background', 'rgba(0, 0, 0, 0.8)');
    this.renderer.setStyle(this.tooltipElement, 'color', 'white');
    this.renderer.setStyle(this.tooltipElement, 'padding', '4px 8px');
    this.renderer.setStyle(this.tooltipElement, 'border-radius', '4px');
    this.renderer.setStyle(this.tooltipElement, 'font-size', '12px');
    this.renderer.setStyle(this.tooltipElement, 'z-index', '10000');
    this.renderer.setStyle(this.tooltipElement, 'pointer-events', 'none');
    this.renderer.setStyle(this.tooltipElement, 'opacity', '0');
    this.renderer.setStyle(this.tooltipElement, 'transition', 'opacity 0.2s');

    const formattedShortcut = this.keyboardService.formatShortcut(this.shortcutKeys);
    const tooltipText = this.shortcutDescription
      ? `${this.shortcutDescription} (${formattedShortcut})`
      : formattedShortcut;

    this.renderer.appendChild(this.tooltipElement, this.renderer.createText(tooltipText));
    this.renderer.appendChild(document.body, this.tooltipElement);
  }

  private showTooltip(): void {
    if (!this.tooltipElement) return;

    const elementRect = this.el.nativeElement.getBoundingClientRect();
    this.renderer.setStyle(this.tooltipElement, 'top', `${elementRect.bottom + 5 + window.scrollY}px`);
    this.renderer.setStyle(this.tooltipElement, 'left', `${elementRect.left + (elementRect.width / 2)}px`);
    this.renderer.setStyle(this.tooltipElement, 'transform', 'translateX(-50%)');
    this.renderer.setStyle(this.tooltipElement, 'opacity', '1');
  }

  private hideTooltip(): void {
    if (this.tooltipElement) {
      this.renderer.setStyle(this.tooltipElement, 'opacity', '0');
    }
  }
}
